import { z } from 'zod';

import { UuidSchema } from '../../common/id/id';

import { MediaAssetSchema } from '../media-asset/media-asset';

/**
 * A **platform-owned** asset as the admin surface sees it (P10.2e).
 *
 * A separate schema rather than two optional fields on `MediaAsset`, for two
 * reasons. `MediaAsset` is the mobile contract too, and `uploadedByUserId` is a
 * staff identity that has no business travelling on a member route (N12). And
 * the read `url` is minted **for this response**: a member's asset list
 * deliberately carries no URLs — a member opens one photo at a time — while an
 * admin library renders a page of thumbnails at once, and minting them one HTTP
 * call at a time would be N+1 requests for a grid.
 *
 * The URL is still per-request, still short-lived, and still authorized before
 * it is minted (the caller holds the kind's manage permission). `expiresAt` is
 * the client's cue to refetch rather than to cache.
 */
export const PlatformMediaAssetSchema = MediaAssetSchema.extend({
  /** The staff account that uploaded it; `null` once that account is deleted. */
  uploadedByUserId: UuidSchema.nullable(),
  url: z.url(),
  expiresAt: z.iso.datetime(),
}).strict();

export type PlatformMediaAsset = z.infer<typeof PlatformMediaAssetSchema>;
